"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const EForumPostCategory_1 = require("../../../../enums/Project/Config/Forum/EForumPostCategory");
const IsUniqueLang_1 = require("../../../decorators/IsUniqueLang");
const I18nTextResource_1 = require("../../../I18nText/I18nTextResource");
const Resource_1 = __importDefault(require("../../../Resource"));
class ForumPostRequestResource extends Resource_1.default {
}
exports.default = ForumPostRequestResource;
__decorate([
    (0, class_transformer_1.Type)(() => I18nTextResource_1.I18nTextResource),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, IsUniqueLang_1.IsUniqueLang)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], ForumPostRequestResource.prototype, "title", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => I18nTextResource_1.I18nTextResource),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, IsUniqueLang_1.IsUniqueLang)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], ForumPostRequestResource.prototype, "description", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(EForumPostCategory_1.EForumPostCategory),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ForumPostRequestResource.prototype, "category", void 0);
